import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignOut, Moon, Sun } from 'phosphor-react';
import Layout from '../../../components/Learner/Layout';
import { logout } from '../../../services/loginApi';
// changed by Cursor: import theme context for dark mode toggle
import { useTheme } from '../../../contexts/ThemeContext';
import './styles.css';

const LearnerProfile = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  // changed by Cursor: dark mode state
  const { isDarkMode, toggleDarkMode } = useTheme();

  useEffect(() => {
    const stored = localStorage.getItem('userData');
    if (stored) {
      setUserData(JSON.parse(stored));
    }
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error('Error during logout:', err);
    }
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    console.log('👋 Logging out...');
    navigate('/learner/login');
  };

  return (
    <Layout>
      <div className="learner-profile-container">
        <h1 className="learner-profile-title">Profile</h1>
        <div className="learner-profile-card">
          <img
            src={userData?.picture || 'https://via.placeholder.com/96'}
            alt="Profile"
            className="learner-profile-pic"
          />
          <p className="learner-profile-name">{userData?.name || 'Learner'}</p>
          {userData?.email && (
            <p className="learner-profile-email">{userData.email}</p>
          )}
        </div>
        {/* changed by Cursor: dark mode toggle button */}
        <button onClick={toggleDarkMode} className="learner-profile-darkmode-btn" aria-label="Toggle dark mode">
          <span className="learner-profile-darkmode-icon">
            {isDarkMode ? <Sun size={20} weight="regular" /> : <Moon size={20} weight="regular" />}
          </span>
          <span>{isDarkMode ? 'Light Mode' : 'Dark Mode'}</span>
        </button>

        <button onClick={handleLogout} className="learner-profile-logout-btn" aria-label="Log out">
          <SignOut size={20} weight="regular" className="learner-profile-logout-icon" />
          <span>Log Out</span>
        </button>
      </div>
    </Layout>
  );
};

export default LearnerProfile;
